(function(){
    angular.module('tmx-app').factory('ManagePrivilegesService', ['tmxResource',
        function(tmxResource){

            var ManagePrivileges = tmxResource("privileges",true);
       // var ManagePrivilegesEdit=tmxResource("");
            ManagePrivileges.checked=false;

            ManagePrivileges.gridColumn = [

                {
                    field: "Name",
                    title: "Name",
                    type: "string",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('PjpName')}\" >Name <i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Name\")' ></i></span>"
                },
                {
                    field: "Description",
                    title: "Description",
                    type: "string",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Description<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                }
            ];
            ManagePrivileges.editGridColumn = [

                {
                    field: "Modules",
                    title: "Modules",
                    headerTemplate:"<md-checkbox  ng-change='ManagePrivilegesEditCtrl.toggleCheckerAll(ManagePrivilegesService.checked)' ng-model='ManagePrivilegesService.checked' ></md-checkbox><span>Modules </span>"

                },
                {
                    field: "View",
                    title: "View",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >View<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"

                },


                {
                    field: "Edit",
                    title: "Edit",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Edit<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                },
                {
                    field: "Delete",
                    title: "Delete",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Delete<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                },
                {
                    field: "Create",
                    title: "Create",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Create<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                }
            ];
            ManagePrivileges.transactionGridColumn = [

                {
                    field: "Modules",
                    title: "Modules",
                    headerTemplate:"<md-checkbox id='chkSelectAll' ng-change='checkAll(ManagePrivileges.checked)' ng-model=' ManagePrivileges.checked' ></md-checkbox><span>Modules </span>"

                },
                {
                    field: "View",
                    title: "View",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >View<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"

                },


                {
                    field: "Edit",
                    title: "Edit",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Edit<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                },
                {
                    field: "Delete",
                    title: "Delete",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Delete<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                },
                {
                    field: "Create",
                    title: "Create",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Add<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                },
                {
                    field: "Assign",
                    title: "Assign",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Assign<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                },
                {
                    field: "Verify",
                    title: "Verify",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Verify<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                },
                {
                    field: "Approve",
                    title: "Approve",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Description')}\" >Approve<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Description\")' ></i></span>"
                }
            ];


            ManagePrivileges.columns = angular.copy(ManagePrivileges.gridColumn);
            ManagePrivileges.editColumns=angular.copy(ManagePrivileges.editGridColumn);
            ManagePrivileges.editTransactionColumns=angular.copy(ManagePrivileges.transactionGridColumn);


            return ManagePrivileges;

        }]);


})();